import {
  type DeserializedRecord,
  deserializeItem,
  deserializeManyRelationship,
  Deserializer,
  JSONAPIManyRelationship,
  JSONAPIRecord
} from "../Helpers";
import {deserializeProgramPhaseComponent, type ProgramPhaseComponent} from "./phase/Component";

interface ProgramPhase extends DeserializedRecord<"program_phase"> {
  name: string;
  durationInDays: number;
  programPhaseComponents: Array<ProgramPhaseComponent>;
}

interface ProgramPhaseData extends JSONAPIRecord {
  relationships: {
    program_phase_components: JSONAPIManyRelationship,
  }
}

const deserializeProgramPhase: Deserializer<ProgramPhase, ProgramPhaseData> = (data, included) => {
  const programPhaseComponents = deserializeManyRelationship<ProgramPhaseComponent>(
    data.relationships.program_phase_components,
    included,
    deserializeProgramPhaseComponent
  );

  return ({
    programPhaseComponents,
    ...deserializeItem(data)
  });
};

export {
  deserializeProgramPhase
};

export type {
  ProgramPhase
};
